import PropTypes from "prop-types";
import { animated } from "@react-spring/web";
import "./Chart.scss";
// import * as service from "./Chart.service.js";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import highchartsAccessibility from "highcharts/modules/accessibility";
import * as config from "./Chart.config.js";

highchartsAccessibility(Highcharts);

/**
 * @component
 * @param {Object} args
 * @param {string} args.chartId
 * @param {"pie" | "bar"} args.chartType - Type of chart to render. Can be "pie" or "bar". Default: "bar".
 * @param {import("./ChartSlide").ChartDatum[]} args.data - Array of data objects to render. Each object must have:
 * @param {"left" | "right"} [args.orientation] - Orientation of the chart. Can be "left" or "right". Default: "left".
 * @param {{ opacity: import("@react-spring/web").SpringValue<number> }} args.springs
 * @param {React.StyleHTMLAttributes<HTMLHeadingElement> | undefined} args.style
 */
function Chart({ chartId, chartType, data, orientation, springs, style }) {
  const configChartType = chartType === "pie" ? "pie" : "bar";
  const options = config.options[configChartType](data);
  return (
    <animated.div
      className={`dataviz__chart${
        orientation ? ` dataviz__chart--${orientation}` : ""
      }`}
      style={{ ...style, ...springs }}
    >
      <HighchartsReact
        id={chartId}
        key={chartId}
        highcharts={Highcharts}
        options={options}
        allowChartUpdate
      />
    </animated.div>
  );
}

Chart.propTypes = {
  chartId: PropTypes.string.isRequired,
  chartType: PropTypes.oneOf(["pie", "bar"]),
  data: PropTypes.arrayOf(
    PropTypes.shape({
      val: PropTypes.number.isRequired,
      name: PropTypes.number.isRequired,
      custom: PropTypes.shape({
        labelPosition: PropTypes.exact({
          x: PropTypes.number,
          y: PropTypes.number,
        }),
        connectorSide: PropTypes.oneOf(["right", "left"]),
      }),
    })
  ).isRequired,
  orientation: PropTypes.oneOf(["left", "right"]),
  // eslint-disable-next-line react/forbid-prop-types
  springs: PropTypes.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  style: PropTypes.object.isRequired,
};

Chart.defaultProps = {
  chartType: "bar",
  orientation: "left",
};

export default Chart;
